export default "__VITE_ASSET__yzHZm6vW__"